<template>
  <div class="download-item">
    <div class="download-item__header">
      <div>
        {{ item.productName }}
      </div>
      <div class="download-item__header-date">
        Ordered {{ formatDate(item.dateAdded) }}
      </div>
    </div>

    <div v-if="item.imageUrl"
         class="download-item__image-container">
      <img :src="item.imageUrl"
           class="download-item__image-blur"
           alt="Download item blured image">
      <img :src="item.imageUrl"
           class="download-item__image"
           alt="Download item image">
    </div>
    <!-- eslint-disable vue/no-v-html-->
    <div class="download-item__description"
         v-html="item.productDescription">
    </div>
    <!-- eslint-enable vue/no-v-html-->
    <div class="download-item__action">
      <a :href="buttonLink"
         class="btn btn-accent-1 btn-full-width">
        {{ buttonText }}
      </a>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "DownloadItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    buttonText () {
      let result = "Download";

      if ( this.item.contentType === 3 ) {
        result = "Access site";
      }

      return result;
    },
    buttonLink () {
      let result = "#";
      if ( this.item.content ) {
        if ( this.item.contentType === 2 ) {
          result = `/product-downloads/${this.item.content.toLowerCase()}`;
        } else if ( this.item.contentType === 3 ) {
          result = this.item.content;
        }
      }
      return result;
    }
  },
  methods: {
    formatDate ( input ) {
      return format( new Date( input ), "dd/MM/yyyy" );
    }
  }
};
</script>

<style lang="less" scoped>
.download-item {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding: 10px;
  margin: 10px;
  border: 2px solid #B2D6D9;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  &__header {
    font-size: 1.2rem;
    font-weight: 700;

    &-date {
      margin-bottom: 5px;
      font-size: 0.9rem;
      font-weight: 500;
      color: #666;
    }
  }

  &__image-container {
    height: 300px;
    margin: 10px 0;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__image-blur {

    // Hide the blurred image in IE and Edge as the css filters do not work

    // Check for IE10+
    @media all and ( -ms-high-contrast: none ), ( -ms-high-contrast: active ) {
      display: none;
    }

    // Check for Edge 12-15
    @supports (-ms-accelerator:true) {
      display: none;
    }

    // Check for Edge 16+
    @supports (-ms-ime-align:auto) {
      display: none;
    }

    position: absolute;
    top: -5%;
    bottom: -5%;
    left: -5%;
    right: -5%;
    object-fit: cover;
    width: 110%;
    height: 320px;
    object-position: 50% 50%;

    filter: blur( 5px ) brightness( 50% );
    -webkit-filter: blur( 5px ) brightness( 50% );
    -moz-filter: blur( 5px ) brightness( 50% );
    -o-filter: blur( 5px ) brightness( 50% );
    -ms-filter: blur( 5px ) brightness( 50% );
  }

  &__image {
    position: relative;
    // min-width: 100%;
    max-height: 300px;
    object-fit: contain;
    z-index: 1000;
    vertical-align: middle;
  }

  &__description {
    flex-grow: 1;
  }

  &__action {
    margin-top: 10px;
  }
}
</style>
